import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Contact() {
  return (
    <div className="min-h-screen">
      <Navbar alwaysSolid />

      <section className="relative pt-20 md:pt-24 h-[calc(100vh-0px)] md:h-screen min-h-[500px] w-full overflow-hidden flex items-center">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20architectural%20interior%20with%20dramatic%20natural%20light%20casting%20soft%20shadows%20on%20warm%20neutral%20surfaces%2C%20abstract%20minimalist%20composition%20with%20elegant%20curved%20elements%2C%20monochromatic%20warm%20grey%20and%20cream%20tones%2C%20refined%20luxury%20real%20estate%20atmosphere%2C%20editorial%20photography%2C%20quiet%20sophisticated%20mood%2C%20empty%20space%20with%20beautiful%20proportions&width=1600&height=900&seq=contact-hero-02&orientation=landscape&nocache=true"
          alt="Contact"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />

        <div className="relative z-10 section-container w-full flex justify-end">
          <div className="max-w-md text-left mr-8 md:mr-14">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-brand-dark mb-10">
              Property Growth
            </h1>

            <div className="space-y-2 mb-10">
              <p className="text-xs font-bold tracking-widest uppercase text-brand-dark">
                REACH US AT
              </p>
              <a
                href="mailto:contact@property-growth.com"
                className="inline-block text-sm text-gray-700 hover:text-brand-gold transition-colors underline underline-offset-4"
              >
                contact@property-growth.com
              </a>
            </div>

            <div className="space-y-2">
              <p className="text-xs font-bold tracking-widest uppercase text-brand-dark">
                REGISTERED OFFICE ADDRESS
              </p>
              <div className="text-sm text-gray-700 leading-relaxed">
                <p>6 Eu Tong Sen Street</p>
                <p>#12-12 The Central</p>
                <p>Singapore 059817</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}